import React from 'react';

import config from '../config';
import makeScriptPromise from '../lib/makeScriptPromise';

const baseUrl = 'https://www.paypal.com/sdk/js';
const defaultParams = `?client-id=${config.paypalId}`;

export default function usePaypalScriptLoader(params = defaultParams) {
  const [isScriptLoaded, setIsScriptLoaded] = React.useState(null);

  React.useEffect(() => {
    makeScriptPromise(`${baseUrl}${params}`)
      .then(() => setIsScriptLoaded(true))
      .catch(() => setIsScriptLoaded(false));
  }, []);

  return isScriptLoaded;
}



// WEBPACK FOOTER //
// ./src/hooks/usePaypalScriptLoader.js